import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';


import image1 from "./images/smu.jpeg";


const SMU = () => {
    const images = [image1];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">SMU Hackathon 2025</h2>
        <span className="section__subtitle">Second place winner🥈</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🚀 Secured <strong>2nd Place</strong> at <strong>SMU Hack 4.0</strong> with <strong>Team Amazighen</strong> for developing <strong>NOVALEARN</strong>, an AI-powered learning assistant revolutionizing education. 💡
                    </p>
                    <p className='redRadio__text'>
                        📚 NOVALEARN integrates <strong>personalized learning</strong>, <strong>adaptive assessments</strong>, <strong>AR-based experiences</strong>, and <strong>multi-agent RAG systems</strong> powered by models like <strong>Llama 3.2</strong> and <strong>Mistral 7B</strong> to make learning more interactive, accessible, and intelligent.
                    </p>
                    <p className='redRadio__text'>
                        💪 Overcame personal challenges during the hackathon to deliver a solution recognized for its innovation and impact in the <strong>EdTech</strong> space. 🌍✨
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default SMU;
